import React, { FC } from "react"

import { px } from "@mantine/core"
import { Icon24Hours } from "@tabler/icons-react"
import dayjs from "dayjs"

import ChartCard from "../../../analytics/components/chart-card/ChartCard"
import useDeviceBarChart from "./useDeviceBarChart"
import { useLanguage } from "../../../../contexts/language-context"

const DeviceBarChart: FC = () => {
    const data = useDeviceBarChart()
    const { L } = useLanguage()

    return (
        <ChartCard
            label={L("Triggers per day")}
            icon={Icon24Hours}
            option={{
                grid: { top: 0, right: 0, bottom: px("1.25rem"), left: 0 },
                tooltip: { trigger: "axis" },
                xAxis: { type: "time" },
                yAxis: { type: "value", min: 0 },
                dataZoom: [
                    {
                        type: "inside",
                        startValue: dayjs().subtract(7, "days").toDate(),
                        endValue: dayjs().endOf("day").toDate(),
                    },
                ],
                series: Object.entries(data).map(([species, data]) => ({
                    type: "bar",
                    stack: "total",
                    name: species,
                    data: data,
                })),
            }}
        />
    )
}

export default DeviceBarChart
